import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=ef06a420&scoped=true&"
import script from "./FormSelect.vue?vue&type=script&lang=ts&"
export * from "./FormSelect.vue?vue&type=script&lang=ts&"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=ef06a420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06a420",
  null
  
)

export default component.exports